var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"quizz-vuetify",attrs:{"quizz-vuetify":""}},[_c('v-main',[_c('Quizz',{attrs:{"questions":_vm.questions,"responses":_vm.responses},on:{"addResponse":_vm.bubbleAddResponse}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }